export default {"src":"/_next/static/media/home-messages-tips-purple.6676f177.svg","height":83,"width":70,"blurWidth":0,"blurHeight":0};